import type { FC } from 'react';
import { useState } from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import WeeklyRevenueTable from './WeeklyRevenueTable';
import IncompleteTimesheetsTable from './IncompleteTimesheetsTable';

const ReportsTab: FC = () => {
  const [expanded, setExpanded] = useState<string | false>(false);
  const [mountedReports, setMountedReports] = useState<Set<string>>(new Set());

  const handleChange = (panel: string) => (_event: React.SyntheticEvent, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : false);

    // Track which reports have been opened so they stay mounted
    if (isExpanded && !mountedReports.has(panel)) {
      setMountedReports(prev => new Set(prev).add(panel));
    }
  };

  return (
    <div>
      <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography>Weekly Revenue</Typography>
        </AccordionSummary>
        <AccordionDetails>
          {mountedReports.has('panel1') && <WeeklyRevenueTable />}
        </AccordionDetails>
      </Accordion>

      <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography>Incomplete Timesheets</Typography>
        </AccordionSummary>
        <AccordionDetails>
          {mountedReports.has('panel2') && <IncompleteTimesheetsTable />}
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export default ReportsTab;
